<!-- <div class="m-t10 flex-row-end"><gp-pvfv-setting></gp-pvfv-setting></div> -->
<div  *ngIf="!isDataAvailable" class="flex-col-center m-t75">       
    <gp-chart-loading-animation></gp-chart-loading-animation>
</div>
<mat-table [dataSource]="dataSource" *ngIf="isDataAvailable"> 
    <ng-container matColumnDef="yr">
        <mat-header-cell *matHeaderCellDef> YEAR </mat-header-cell>
        <mat-cell class="p-r10" *matCellDef="let element"> 
            <div class="flex-col-container">
                <span> {{element.yr}} </span>
                <span class="gray-text font14"><span class="B m-r3">Age:</span> {{element.c1Age}} </span>
            </div>
        </mat-cell>
    </ng-container>       
    <ng-container matColumnDef="portBeginBal">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align">STARTING <br> BALANCE</span>  </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.portBeginBal<0}">
            {{element.portBeginBal | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>      
    <ng-container matColumnDef="totIncome">
        <mat-header-cell *matHeaderCellDef class="th-right"> INCOME </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.totIncome<0}">
            {{element.totIncome | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="portInc">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align">PORTFOLIO <br> INCOME</span> </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.portInc<0}">
            {{element.portInc | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totExpense">
        <mat-header-cell *matHeaderCellDef class="th-right"> EXPENSES </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.totExpense<0}">
            {{element.totExpense | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="totTax">
        <mat-header-cell *matHeaderCellDef class="th-right"> TAXES </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.totTax<0}">
            {{element.totTax | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container>  
    <ng-container matColumnDef="portTaxes">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align">PORTFOLIO <br> TAXES</span> </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.portTaxes<0}">
            {{element.portTaxes | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container> 
    <ng-container matColumnDef="totSavings">
        <mat-header-cell *matHeaderCellDef class="th-right"> SAVINGS </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.totSavings<0}">
            {{element.totSavings | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="netCashFlow">
        <mat-header-cell *matHeaderCellDef class="th-right"> NET CASH FLOW </mat-header-cell>
        <mat-cell class="p-r10 th-right" *matCellDef="let element" [ngClass]="{'negative': element.netCashFlow<0}">
            {{element.netCashFlow | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="portEndBal">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align">ENDING <br> BALANCE</span>   </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.portEndBal<0}">
            {{element.portEndBal | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
    <mat-row mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
</mat-table> 